import { STRATEGY_OPTION } from 'enums';
import { strategy_message } from 'pages/private/strategy/constants';
import { uuidv4 } from 'utils/uuid';

import { StrategyOption } from './types';

export const strategy_options: StrategyOption[] = [
  {
    name: 'Edit Strategy',
    message: '',
    id: STRATEGY_OPTION.UPDATE_STRATEGY,
    uuid: uuidv4(),
  },
  {
    name: 'Activate Strategy',
    message: strategy_message[STRATEGY_OPTION.ACTIVATE_STRATEGY] || '',
    id: STRATEGY_OPTION.ACTIVATE_STRATEGY,
    uuid: uuidv4(),
  },
  {
    name: 'Archive Strategy',
    message: strategy_message[STRATEGY_OPTION.ARCHIVE_STRATEGY] || '',
    id: STRATEGY_OPTION.ARCHIVE_STRATEGY,
    uuid: uuidv4(),
  },
];
